import { Component } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {filter, Subscription} from "rxjs";
import {TitleService} from "../../../../services/title.service";
import {TranslateService} from "@ngx-translate/core";
import {ConfigService} from "../../../../services/config.service";
@Component({
  selector: 'app-legal-section',
  templateUrl: './legal-section.component.html',
  styleUrls: ['./legal-section.component.scss']
})
export class LegalSectionComponent {
  selectedLegalSectionTitle: string;
  routeSubs?: Subscription
  titleTranslateSubs?: Subscription

  complaintsNeeded: boolean;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private titleService: TitleService,
    private configs: ConfigService
  ) {
    this.complaintsNeeded = false; //todo remove this and use this below
    // this.complaintsNeeded = this.configs.name === 'purecasino'; //todo

    const section = this.router.url.split('/')[2].split("_")[0].toUpperCase();
    this.selectedLegalSectionTitle = ((section === "COMPLAINTS" && this.complaintsNeeded) ? "PURE." : "LEGAL.") +  section + ".TITLE";
    this.titleTranslateSubs = this.translate.stream(this.selectedLegalSectionTitle).subscribe(data => {
      this.titleService.setTitle(`Lobby / ${data}`);
    })

  }

  ngOnInit(){
    this.routeSubs = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {

      const section = event.url.split('/')[2].split("_")[0].toUpperCase();
      this.selectedLegalSectionTitle = ((section === "COMPLAINTS" && this.complaintsNeeded) ? "PURE." : "LEGAL.") + section + ".TITLE";

      this.titleTranslateSubs?.unsubscribe();
      this.titleTranslateSubs = this.translate.stream(this.selectedLegalSectionTitle).subscribe(data => {
        this.titleService.setTitle(`Lobby / ${data}`);
      })

    });
  }

  ngOnDestroy(){
    this.routeSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();
  }
}
